<template>
    <div>
        <div class="columns">
            <div class="column is-6 is-offset-3">
                <bundle-form :create="true" @saved="editBundle"></bundle-form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {}
        },
        methods: {
            editBundle(bundle) {
                this.$router.push({name: 'bundle', params: {id: bundle.id}})
            }
        }
    };
</script>



// WEBPACK FOOTER //
// BundleCreate.vue?fd5593b4